/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunityDto } from '../../models/community-dto';

export interface CommunityControllerLikedV1$Params {
}

export function communityControllerLikedV1(http: HttpClient, rootUrl: string, params?: CommunityControllerLikedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityDto>>> {
  const rb = new RequestBuilder(rootUrl, communityControllerLikedV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CommunityDto>>;
    })
  );
}

communityControllerLikedV1.PATH = '/api/v1/community/liked';
